module.exports = __webpack_public_path__ + "static/media/arbeitsmittel_active_true.24f8ef94.jpg";